// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vs--single:not(.vs--open) .vs__selected+.vs__search{width:0;padding:0;margin:0;border:none;height:0}.vs--single .vs__selected-options{width:0}.vs--single .vs__selected{display:block;white-space:nowrap;text-overflow:ellipsis;max-width:100%;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
